<script setup>
import { computed } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';

const props = defineProps({
  data: { type: Array, default: () => [] },
});

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

const chartData = computed(() => ({
  labels: props.data.map(d => d.date?.slice(5) ?? ''),
  datasets: [
    {
      label: 'Positivo',
      data: props.data.map(d => d.positive),
      borderColor: '#059669',
      backgroundColor: 'rgba(5,150,105,0.15)',
      tension: 0.4,
      fill: true,
    },
    {
      label: 'Negativo',
      data: props.data.map(d => d.negative),
      borderColor: '#dc2626',
      backgroundColor: 'rgba(220,38,38,0.15)',
      tension: 0.4,
      fill: true,
    },
    {
      label: 'Neutro',
      data: props.data.map(d => d.neutral),
      borderColor: '#64748b',
      backgroundColor: 'rgba(100,116,139,0.15)',
      tension: 0.4,
      fill: true,
    },
  ],
}));

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'bottom' },
  },
  scales: {
    y: { beginAtZero: true, ticks: { precision: 0 } },
  },
};
</script>

<template>
  <div class="rounded-xl border border-n-weak bg-n-background p-4">
    <h3 class="mb-3 text-sm font-semibold text-n-slate-12">
      Sentimento ao longo do tempo
    </h3>
    <div class="h-64">
      <Line v-if="data.length" :data="chartData" :options="options" />
      <div
        v-else
        class="flex h-full items-center justify-center text-sm text-n-slate-11"
      >
        Sem dados no período.
      </div>
    </div>
  </div>
</template>
